
import { useEffect, useState } from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
import { checkAccess, getUserPermissions } from '../../utils/admins';
import { handleChange, handleSendNotification } from './PushNotification.services';
import { Input, Modal, Switch, Paper } from '../../components';
import { ALLSHOP } from '../../constants'
import store from '../../utils/store'

export function PushNotifModal({ stateObj, setStateObj, classes, openErrorModal }) {

  const { shop = {} } = store.getState().firebaseRealTime;
  const { shopId, nbShops } = store.getState().user;
  const [isShopAdmin, setIsShopAdmin] = useState(false);
  const isAdminOfOneShop = nbShops === 1 && !isShopAdmin

  useEffect(() => {
    (async () => {
      const { isAdminOfThisShop } = await getUserPermissions(shopId);
      setIsShopAdmin(isAdminOfThisShop)
    })()
  }, [shopId])

  return <Modal
    size="lg"
    showCancelBtn
    header
    isOpen={stateObj.modalOpen}
    title="Push Notifications"
    onClick={() => handleSendNotification(setStateObj, stateObj.title, stateObj.message, stateObj.toAllUsers, isAdminOfOneShop, stateObj.users, stateObj.allUsers, shopId, openErrorModal)}
    btnTxt="Enregistrer"
    handleClose={() => {
      setStateObj({ modalOpen: false, toAllUsers: false });
    }}
    loading={stateObj.isLoadingModal}
  >
    <>
      <div>
        <h5 className="pb-2">{`Envoi d'une nouvelle Push notification à vos ${stateObj.toAllUsers || isAdminOfOneShop ? _.size(stateObj.allUsers) : _.size(stateObj.users)} utilisateurs`}</h5>
        {checkAccess('features', 'globalPushNotifs') && nbShops > 1 && (
          <Paper variant="outlined" className="my-2">
            <div className="d-flex mx-3">
              <p className={classes.labelStyle}>Cible</p>
              <FormGroup style={{ width: '-webkit-fill-available' }}>
                <div>
                  <Grid
                    component="label"
                    container
                    alignItems="center"
                    spacing={1}
                    className={classes.grid}
                  >
                    <div>{shop.name}</div>
                    <div>
                      <Switch
                        onChange={e => handleChange(e, setStateObj)}
                        id="toAllUsers"
                        inputProps={{
                          'aria-label': 'primary checkbox'
                        }}
                      />
                    </div>
                    <div>{ALLSHOP}</div>
                  </Grid>
                </div>
              </FormGroup>
            </div>
          </Paper>
        )}
        <Input
          autoFocus
          margin="dense"
          id="Title"
          maxLength={40}
          label="Titre de la notification"
          type="text"
          value={stateObj.title}
          onChange={e => setStateObj({ title: e.target.value })}
          fullWidth
        />
        <Input
          margin="dense"
          multiline
          rows="2"
          id="Message"
          maxLength={160}
          label="Message de la notification"
          type="text"
          value={stateObj.message}
          onChange={e => setStateObj({ message: e.target.value })}
          fullWidth
        />
      </div>
    </>
  </Modal>
}